module.exports = "<ul>\r\n  <ng-content></ng-content>\r\n</ul>\r\n"